import React, { Fragment } from 'react';
import Portal from '../../utils/Portal';
import { PointsRing } from './AmountCircle';
import { useSettings } from '../../mall_settings/SettingsProvider';

const AmountCirclePortal = () => {
    const { userPoints } = useSettings();
    return (
        <Fragment>
            {userPoints && (
                <Portal id="amount_circle">
                    <PointsRing />
                </Portal>
            )}
        </Fragment>
    );
};

export default AmountCirclePortal;
